export default "__VITE_ASSET__3mOC0xNY__"